"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _configuratorSecondaryNavigation = _interopRequireDefault(require("../styles/configurator-secondary-navigation.css"));
var _backLink = _interopRequireDefault(require("./back-link"));
var _stepsWrapper = _interopRequireDefault(require("./steps-wrapper"));
var _configuratorSecondaryNavigation2 = require("./configurator-secondary-navigation.props/configurator-secondary-navigation.propTypes");
var _nextStep = _interopRequireDefault(require("./next-step"));
var getActivePhase = function getActivePhase(phases) {
  var activePhase = null;
  for (var i = 0; i < phases.length; i += 1) {
    var activeStepIndex = phases[i].steps.findIndex(function (step) {
      return step.selected;
    });
    if (activeStepIndex !== -1) {
      activePhase = i;
      break;
    }
  }
  return activePhase;
};
var ConfiguratorSecondaryNavigation = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorSecondaryNavigation, _React$Component);
  ConfiguratorSecondaryNavigation.resourceType = function resourceType() {
    return 'ConfiguratorSecondaryNavigation_1_0_0';
  };
  function ConfiguratorSecondaryNavigation(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.scrollablePane = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  var _proto = ConfiguratorSecondaryNavigation.prototype;
  _proto.renderSteps = function renderSteps() {
    var _clsx;
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme;
    var activePhase = getActivePhase(data.phases);
    if (activePhase === 0) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx2["default"])(_configuratorSecondaryNavigation["default"].wrapper, _configuratorSecondaryNavigation["default"].grey_arrow),
        automation: "secondary-nav-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _configuratorSecondaryNavigation["default"].backLink,
        automation: "backlink-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_backLink["default"], {
        link: data.phases[0].previousCta,
        activePhase: activePhase,
        theme: theme
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _configuratorSecondaryNavigation["default"].stepsWrapper,
        automation: "steps-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_stepsWrapper["default"], {
        phase: data.phases[0],
        scrollablePane: this.scrollablePane
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _configuratorSecondaryNavigation["default"].nextSteps,
        automation: "next-steps-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_nextStep["default"], {
        step: data.phases[0].nextSteps
      })));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_configuratorSecondaryNavigation["default"].wrapper, _configuratorSecondaryNavigation["default"].white_arrow),
      automation: "secondary-nav-wrapper"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_configuratorSecondaryNavigation["default"].backLink, (_clsx = {}, _clsx[_configuratorSecondaryNavigation["default"].darkRTL] = activePhase === 1, _clsx)),
      automation: "backlink-wrapper"
    }, /*#__PURE__*/_react["default"].createElement(_backLink["default"], {
      theme: theme,
      link: data.phases[1].previousCta,
      activePhase: activePhase
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorSecondaryNavigation["default"].stepsWrapper,
      automation: "steps-wrapper"
    }, /*#__PURE__*/_react["default"].createElement(_stepsWrapper["default"], {
      phase: data.phases[1],
      scrollablePane: this.scrollablePane
    })));
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      direction = _this$props2.direction;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(theme['container-fluid'], _configuratorSecondaryNavigation["default"].container),
      automation: "secondary-nav-container",
      ref: this.scrollablePane,
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row,
      automation: "secondary-nav-row"
    }, this.renderSteps()));
  };
  return ConfiguratorSecondaryNavigation;
}(_react["default"].Component);
exports["default"] = ConfiguratorSecondaryNavigation;
ConfiguratorSecondaryNavigation.displayName = 'ConfiguratorSecondaryNavigation';